<script setup lang="ts">
import type { DynamicDialogInstance } from 'primevue/dynamicdialogoptions';

const dialogRef = inject<Ref<DynamicDialogInstance>>('dialogRef');

const upgrade = () => {
  dialogRef?.value.close();
  navigateTo('/pricing');
};

const close = () => {
  dialogRef?.value.close();
};

</script>

<template>
  <div class="max-w-lg">
    <h3 class="text-16">
      This resource is part of our premium learning experience, reserved for our paying members.
    </h3>
    <p>
      By upgrading your account, you'll gain:
    </p>
    <ul class="pl-4">
      <li class="mb-2">
        <b>Downloadable resources</b>, cheat sheets, and reference material
      </li>
      <li class="mb-2">
        Full access to <b>110+ courses and 25 case-based</b> workshops
      </li>
      <li class="mb-2">
        Earn certificates for completing courses and workshops
      </li>
      <li class="mb-2">
        <b>Earn CME credits</b> and certificates upon completion (available to Pro members)
      </li>
    </ul>
    <p>
      Don't miss the chance to truly boost your clinical skills!
    </p>
    <div class="flex justify-end gap-4">
      <Button
        outlined
        severity="secondary"
        @click="close"
      >
        Cancel
      </Button>
      <Button
        class="bg-yellow-50 text-neutral-80 font-bold text-bold border-none text-nowrap"
        @click="upgrade"
      >
        Upgrade now
      </Button>
    </div>
  </div>
</template>